
import {User} from '@tc-core/model/it/codegen/tbx/api/authority/v2/users/user';
import {ComponentAttribute} from '../models/chat-component.model';
import {HotelSummary} from '../models/hotel-summary.model';


/**
 * Map raw table rows to HotelSummary objects
 */
export function mapToHotelSummary(rows: { [key: string]: string }[]): HotelSummary[] {
  return rows.map(row => {
    // Default fallback values
    const hotelSummary: HotelSummary = {
      name: 'Unknown Hotel',
      address: 'Address not available',
      starRating: 0,
      availability: true,
      price: 'Search for price',
      cheapestRoomType: 'Multiple rooms',
      cheapestMealPlan: 'Multiple options',
      nonRefundable: false
    };

    // Regexes for parsing if needed
    const actionRegex = /@@action\|([^|]+)\|([^|]+)\|([^@]+)@@/;
    const starRatingRegex = /^(\d+)/;

    for (const key of Object.keys(row)) {
      const lowerKey = key.toLowerCase();
      const value = row[key];

      if (lowerKey.includes('hotel') || lowerKey.includes('name')) {
        const match = value?.match(actionRegex);
        hotelSummary.name = match ? match[1] : value || hotelSummary.name;
      }
      if (lowerKey.includes('address')) {
        hotelSummary.address = value || hotelSummary.address;
      }
      if (lowerKey.includes('stars') || lowerKey.includes('rating')) {
        const match = value?.match(starRatingRegex);
        hotelSummary.starRating = match ? parseInt(match[1], 10) : hotelSummary.starRating;
      }
      if (lowerKey.includes('availability')) {
        hotelSummary.availability = value?.toLowerCase().includes('available') ?? hotelSummary.availability;
      }
      if (lowerKey.includes('price')) {
        hotelSummary.price = value || hotelSummary.price;
      }
      if (lowerKey.includes('room')) {
        hotelSummary.cheapestRoomType = value || hotelSummary.cheapestRoomType;
      }
      if (lowerKey.includes('meal')) {
        hotelSummary.cheapestMealPlan = value || hotelSummary.cheapestMealPlan;
      }
      if (lowerKey.includes('refundable')) {
        hotelSummary.nonRefundable = value !== undefined ? value === 'No' : hotelSummary.nonRefundable;
      }
    }

    return hotelSummary;
  });
}

/**
 * Build hotel search URL from payload attributes and user info
 */
export function buildHotelSearchUrl(
  baseUrl: string,
  payloadAttributes: ComponentAttribute[],
  user: User
): string {
  const params: { [key: string]: string } = {};
  payloadAttributes.forEach(attr => (params[attr.name] = attr.value));

  const baseParams: { [key: string]: string } = {
    cmp: 'DA_UAE',
    div: 'FIT_UAE',
    brand: 'FIT- Local',
    channel: 'B',
    cur: 'AED',
    bkgType: 'STD',
    cliGrp: 'WOUT',
    cliType: 'TRADE_CLIENT',
    srcCountry: 'DE',
    cliId: user?.clientId?.toString() || '15500',
    userId: '21323',
    username: user?.userSummary?.firstName || 'Chehani',
    resultsCount: '300',
    adult: '2~30~~1',
    startDate: '2026-11-07T00:00:00',
    nights: '1',
    destinationType: 'CITY',
    destinationCode: 'DXB',
    dn: 'Dubai',
    isRoomWise: 'true',
    dp: 'United Arab Emirates',
    expand: 'summary,detail,rate,source',
    enableSourceSummaryCache: 'true',
    availableOnly: 'true',
    sources: 'tbx~1~4',
    attributes: 'ENABLE_FILTERED_RESULTS~true,EXCLUDE_ON_REQUEST~true,ENABLE_B2B_SEARCH~true',
  };

  // Override baseParams with payload values
/*  if (params.hotel) {
    baseParams.hotelCode = params.hotel;
  }*/
  if (params.startDate) {
    baseParams.startDate = params.startDate.replace(/\//g, '-') + 'T00:00:00';
  }
  if (params.nights) {
    baseParams.nights = params.nights;
  }
  if (params.adults) {
    baseParams.adult = `${params.adults}~30~~1`;
  }

  const urlParams = new URLSearchParams();
  Object.keys(baseParams).forEach(key => urlParams.append(key, baseParams[key]));

  return `${baseUrl}/b2b-hotels/?${urlParams.toString()}`;
}

